module.exports = __webpack_public_path__ + "img/vertical_6_1_5012.a0cd5126.png";